(function () {
  if (window.KaremaAurelys) return;
  var K = window.KaremaAurelys = { qty: null, variant: null, mode: 'checkout', label: '', price: '' };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function each(sel, fn, scope) { Array.prototype.forEach.call((scope || document).querySelectorAll(sel), fn); }

  function setText(scope, sel, val) {
    each(sel, function (el) {
      if (val) { el.textContent = val; el.hidden = false; } else { el.hidden = true; }
    }, scope);
  }

  function apply(qty) {
    var found = false;
    each('[data-karema-packs]', function (packs) {
      var chosen = null;
      each('[data-kpk-card]', function (card) {
        var on = String(card.getAttribute('data-qty')) === String(qty);
        card.classList.toggle('is-selected', on);
        var input = card.querySelector('input');
        if (input) input.checked = on;
        if (on) chosen = card;
      }, packs);
      if (!chosen) return;
      found = true;
      K.variant = packs.getAttribute('data-variant');
      K.mode = packs.getAttribute('data-mode') || 'checkout';
      K.label = chosen.getAttribute('data-label');
      K.price = chosen.getAttribute('data-price');
      setText(packs, '[data-kpk-now]', chosen.getAttribute('data-price'));
      setText(packs, '[data-kpk-was]', chosen.getAttribute('data-was'));
      var off = chosen.getAttribute('data-off');
      setText(packs, '[data-kpk-off]', off && off !== '0' ? off + '% OFF' : '');
      setText(packs, '[data-kpk-cuota]', chosen.getAttribute('data-cuota'));
      setText(packs, '[data-kpk-save]', chosen.getAttribute('data-save'));
    });
    if (!found) return false;
    K.qty = qty;
    each('[data-kstc-label]', function (el) { el.textContent = K.label; });
    each('[data-kstc-price]', function (el) { el.textContent = K.price; });
    return true;
  }

  function buy(btn) {
    var fixedQty = btn.getAttribute('data-pack-qty');
    var variant = fixedQty ? btn.getAttribute('data-variant') : (K.variant || btn.getAttribute('data-variant'));
    var qty = parseInt(fixedQty || K.qty || btn.getAttribute('data-qty') || '1', 10);
    var mode = (fixedQty || !K.variant) ? (btn.getAttribute('data-mode') || 'checkout') : K.mode;
    if (!variant) { if (btn.getAttribute('href')) window.location.href = btn.getAttribute('href'); return; }
    btn.classList.add('is-loading');
    if (mode === 'cart') {
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variant), quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add');
        window.location.href = root + 'cart';
      }).catch(function () {
        window.location.href = root + 'cart/' + variant + ':' + qty;
      });
    } else {
      window.location.href = root + 'cart/' + variant + ':' + qty;
    }
  }

  function addBusinessDays(n) {
    var d = new Date();
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var w = d.getDay();
      if (w !== 0 && w !== 6) added++;
    }
    return d;
  }

  function fmtDate(d) {
    try {
      return d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'long' }).replace(',', '');
    } catch (e) {
      return d.getDate() + '/' + (d.getMonth() + 1);
    }
  }

  function eta() {
    each('[data-kpk-eta]', function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 2;
      var max = parseInt(el.getAttribute('data-max'), 10) || 4;
      var tpl = el.getAttribute('data-tpl') || '';
      if (!tpl) return;
      el.textContent = tpl.replace('[desde]', fmtDate(addBusinessDays(min))).replace('[hasta]', fmtDate(addBusinessDays(max)));
      el.hidden = false;
    });
  }

  function sticky() {
    var main = document.querySelector('[data-karema-main-cta]');
    each('[data-kstc]', function (bar) {
      if (bar.getAttribute('data-kstc-ready') === '1') return;
      bar.setAttribute('data-kstc-ready', '1');
      if (bar.getAttribute('data-mode') === 'always' || !main) {
        bar.classList.add('is-visible');
        document.documentElement.classList.add('kstc-on');
        return;
      }
      function check() {
        var passed = main.getBoundingClientRect().bottom < 0;
        bar.classList.toggle('is-visible', passed);
        document.documentElement.classList.toggle('kstc-on', passed);
      }
      window.addEventListener('scroll', check, { passive: true });
      window.addEventListener('resize', check);
      check();
    });
  }

  function packFromUrl() {
    try {
      var p = new URLSearchParams(window.location.search).get('pack');
      return p ? String(parseInt(p, 10)) : null;
    } catch (e) { return null; }
  }

  function init() {
    var fromUrl = packFromUrl();
    if (!(fromUrl && apply(fromUrl))) {
      var first = document.querySelector('[data-karema-packs] [data-kpk-card].is-selected') || document.querySelector('[data-karema-packs] [data-kpk-card]');
      if (first) apply(first.getAttribute('data-qty'));
    }
    eta();
    sticky();
  }

  document.addEventListener('change', function (e) {
    var card = e.target && e.target.closest && e.target.closest('[data-kpk-card]');
    if (card) apply(card.getAttribute('data-qty'));
  });

  document.addEventListener('click', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-karema-select]');
    if (sel) {
      if (apply(sel.getAttribute('data-karema-select'))) {
        e.preventDefault();
        var target = document.getElementById((sel.getAttribute('href') || '').split('#')[1] || '') || document.querySelector('[data-karema-packs]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      return;
    }
    var btn = e.target && e.target.closest && e.target.closest('[data-karema-buy]');
    if (!btn) return;
    e.preventDefault();
    buy(btn);
  });

  window.addEventListener('pageshow', function () {
    each('.is-loading', function (el) { el.classList.remove('is-loading'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
})();
